import {gql, useQuery,} from "@apollo/client";
import {Box, SimpleGrid, Spinner, Flex} from "@chakra-ui/react";
import Product from "../../../components/card/Product";
import {PlatformBrandContext} from "contexts/PlatformContext";
import React, {useState, useContext, useMemo} from "react";
import ParameterSelectionBar from "./ParameterSelectionBar";


function processProductsData(loading, error, data) {
    const empty = {}
    if (loading) return {loading, error, empty}
    if (error) return {loading, error, empty}
    let grouped_products = {};
    let products = data.customers[0].customer_brands.map(x => x.customer_brands_to_products).flat()


    for (let product of products) {
        if (!(product.product_family in grouped_products)) {
            grouped_products[product.product_family] = {
                product_rating: {},
                product_image_url: product.product_image_url,
                reviews_count: {},
                total_reviews_count: 0,
                brand: "",
                product_names: []
            }
        }
        if (product.product_universal_id == null) {
            console.log("!!!Undefined product", product)
        }
        let grouped_product_instance = grouped_products[product.product_family];
        if (!(product.product_universal_id in grouped_product_instance.product_rating)) {
            grouped_product_instance.product_rating[product.product_universal_id] = {};
        }
        grouped_product_instance.product_rating[product.product_universal_id][product.platform] = product.product_rating;

        if (!(product.product_universal_id in grouped_product_instance.reviews_count)) {
            grouped_product_instance.reviews_count[product.product_universal_id] = {};
        }
        grouped_product_instance.reviews_count[product.product_universal_id][product.platform] = product.texts_aggregate.aggregate.count;
        grouped_product_instance.total_reviews_count += product.texts_aggregate.aggregate.count
        grouped_product_instance.brand = product.brand
        grouped_product_instance.product_names.push(product.name)
    }
    return {loading, error, grouped_products};
}

function filterProductsSearch(groupedProducts, query) {
    if (!query) {
        return groupedProducts;
    }
    let filteredProducts = {}
    for (const [productFamily, value] of Object.entries(groupedProducts)) {
        if (productFamily.toLowerCase().includes(query)) {
            filteredProducts[productFamily] = value;
        } else {
            for (const name of value.product_names) {
                if (name.toLowerCase().includes(query)) {
                    filteredProducts[productFamily] = value;
                    break;
                }
            }
        }
    }
    return filteredProducts;
}

function filterProductsBrand(groupedProducts, brands) {
    let filteredProducts = {}
    for (const [productFamily, value] of Object.entries(groupedProducts)) {
        if (brands.includes(value.brand)) {
            filteredProducts[productFamily] = value;
        }
    }
    return filteredProducts
}

function useLoadAllProducts(customer, platforms) {
    const {loading, error, data} = useQuery(gql`
            query LoadAllProducts($customer: String!, $limit: Int = 3000, $offset: Int = 0, $platforms: [String!] = "") {
              customers(where: {customer: {_eq: $customer}}) {
                active
                pretty_name
                customer_brands {
                  brand
                  customer_brands_to_products(limit: $limit, offset: $offset, where: {platform: {_in: $platforms}}) {
                    brand
                    product_rating: data(path: "$.product_rating")
                    product_image_url: data(path: "$.product_image_url")
                    name
                    platform
                    product_family
                    product_platform_id
                    product_universal_id
                    texts_aggregate {
                      aggregate {
                        count
                      }
                    }
                  }
                }
              }
            }
`, {
        variables: {
            customer: customer,
            platforms: platforms
        },
    });
    return useMemo(() => processProductsData(loading, error, data), [loading, error, data])

}


function WrappedProductGrid(props) {
    const {addToCompare} = props
    const {platforms, allBrands} = useContext(PlatformBrandContext);
    const [searchQuery, setSearchQuery] = useState('');
    let {
        loading,
        error,
        grouped_products: allGroupedProducts
    } = useLoadAllProducts(localStorage.getItem("customerName"), platforms)
    const [brandsSelected, setBrandsSelected] = useState(allBrands)
    const brandSelectedNames = brandsSelected.map(x => x.brand)

    console.log("ALLGROUPED_PRODUCTS", allGroupedProducts)
    console.log("BRANDSSELECTED", brandsSelected)
    console.log("PRODUCT GRID AVAILABLE BRANDS", allBrands)
    console.log("PRODUCT GRID PLATFORMS", platforms)
    console.log("SEARCH QUERY", searchQuery);
    // TODO: Make the reviews count aggregate be pre-computed in db

    let grouped_products = {}
    if (error) return `Error! ${error.message}`;
    console.log("brandSelectedNames", brandSelectedNames)
    if (!loading) {
        grouped_products = filterProductsBrand(allGroupedProducts, brandSelectedNames);
        grouped_products = filterProductsSearch(grouped_products, searchQuery)
    }
    //let grouped_products = allGroupedProducts
    return (
        <Flex align='center' justify='center'>
            <Box pt={{base: "24px", md: "24px", xl: "24px"}} w='95%' align='center' mb="300px">
                <ParameterSelectionBar brands={brandsSelected} setBrands={setBrandsSelected}
                                       availableBrands={allBrands} searchQuery={searchQuery}
                                       setSearchQuery={setSearchQuery}/>
                {loading ? <Box pt={{base: "130px", md: "80px", xl: "80px"}}><Spinner/></Box> :
                    <SimpleGrid minChildWidth={{base: "150px", md: "210px", xl: "250px"}} spacing="20px" mt='24px'>
                        {Object.entries(grouped_products).map(x => <Product image={x[1].product_image_url ?? ""}
                                                                            name={x[0]} ratings={x[1].product_rating}
                                                                            review_count={x[1].total_reviews_count}
                                                                            key_={x[0]}
                                                                            key={x[0]}
                                                                            addToCompare={addToCompare}/>)}
                    </SimpleGrid>}
            </Box>
        </Flex>
    )

}

function ProductGridComparison(prevProps, nextProps) {
    return true;
}

export default React.memo(WrappedProductGrid, ProductGridComparison);